<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Plantas</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <vue-json-to-csv
            :json-data="itemsToExport"
            :csv-title="'plantas-' + new Date().valueOf()"
            :labels="labels"
            style="visibility: hidden"
          >
            <!--   <button>
              <b>My custom button</b>
            </button> -->
            <base-button size="sm" type="neutral" ref="myBtn"
              >Exportar</base-button
            >
          </vue-json-to-csv>
          <base-button
            size="sm"
            type="neutral"
            @click="exportData()"
            :loading="loading"
            >Exportar</base-button
          >
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="p-2">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por nombre, direccion..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
              </div>
              <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="tipos"
                @sort-change="sortChange"
              >
                <div slot="empty" v-if="loading">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>

                <el-table-column
                  label="Nombre"
                  prop="alias"
                  sortable="custom"
                  min-width="120px"
                />
                <el-table-column
                  label="CIF"
                  prop="cif"
                  sortable="custom"
                  min-width="70px"
                />
                <el-table-column
                  label="Teléfono"
                  prop="telefono"
                  sortable="custom"
                  min-width="70px"
                />
                <el-table-column
                  label="Ciudad"
                  prop="ciudad"
                  sortable="custom"
                  min-width="100px"
                />

                <!--   <el-table-column
                  label="Dirección"
                  prop="direccion"
                  sortable="custom"
                  min-width="160px"
                /> -->

                <el-table-column
                  label="Dirección"
                  sortable="custom"
                  min-width="160px"
                >
                  <template v-slot="{ row }">
                    <a
                      :href="
                        'https://maps.google.com/?q=' +
                        row.direccion +
                        ' ' +
                        row.ciudad
                      "
                      target="_blank"
                      class="font-weight-bold"
                    >
                      <b>{{ row.direccion }}</b></a
                    >
                  </template>
                </el-table-column>

                <el-table-column label="Acciones" align="left" :min-width="60">
                  <div slot-scope="{ row }" class="table-actions">
                    <base-button
                      outline
                      size="sm"
                      type="primary"
                      @click="listUsers(row.id)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Usuarios</base-button
                    >
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "@/components/";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");

import VueJsonToCsv from "vue-json-to-csv";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      query: null,
      tipos: [],
      selectedRows: [],
      sort: "createdAt",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },

      total: 0,
      loading: false,

      itemsToExport: [],

      labels: {
        razonSocial: { title: "Nombre" },
        cif: { title: "CIF" },
        telefono: { title: "Estado" },
        "usuario.data.attributes.username": { title: "Teléfono" },
        codigo_postal: {
          title: "Código postal",
        },
        ciudad: {
          title: "Ciudad",
        },
        provincia: {
          title: "Provinicia",
        },
        pais: {
          title: "País",
        },
      },
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      await this.$store.dispatch("profile/me");
      let me = await this.$store.getters["profile/me"];
      this.tipos = me.empresas;
      this.total = me.empresas.length;

      this.itemsToExport = me.empresas;
      this.loading = false;
    },

    async exportData() {
      this.loading = true;
      await this.$store.dispatch("profile/me");
      let me = await this.$store.getters["profile/me"];
      this.tipos = me.empresas;
      this.total = me.empresas.length;

      var itemsFlatten = [];
      me.empresas.forEach((item) => {
        itemsFlatten.push(this.flattenObject(item));
      });

      console.log(itemsFlatten);

      this.itemsToExport = itemsFlatten;

      setTimeout(() => {
        this.$refs.myBtn.$el.click();
        this.loading = false;
      }, 500);
    },
    flattenObject(obj) {
      let flattenKeys = {};
      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          // flattenKeys[i] = obj[i];
          let flatObject = this.flattenObject(obj[i]);
          for (let j in flatObject) {
            if (!flatObject.hasOwnProperty(j)) continue;
            flattenKeys[i + "." + j] = flatObject[j];
          }
        } else {
          flattenKeys[i] = obj[i];
        }
      }
      return flattenKeys;
    },

    async deleteTipo(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default empresa.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Eliminar esta empresa?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "No, mantenerlo",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("empresas/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Empresa eliminada correctamente.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "This Empresa still has associated Items.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
    addTipo() {
      this.$router.push({ name: "Add Empresa" });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit Empresa",
        params: { id: row.id },
      });
    },
    listUsers(row) {
      console.log(row);
      this.$router.push({
        name: "List Users",
        params: { idEmpresa: row },
      });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else {
        this.sort = `${prop}:asc`;
      }
      this.getList();
    },
  },
};
</script>
